module.exports = __webpack_public_path__ + "static/series_2900-b4031a1505ceb4661ac7f93a1cb48de7.png";